export const maxTagNameValidator = {
  validate: (tags: any[], { max = 15 }: any) => tags.every(t => t.value.length <= max),
};
